<template>
<div>

   <b-dropdown split split-href="apps" text="Account" class="m-2">
    <b-dropdown-item to="apps/7654321">7654321</b-dropdown-item>
    <b-dropdown-item to="apps/2345678">2345678</b-dropdown-item>
    <b-dropdown-item to="apps/3456789">3456789</b-dropdown-item>
  </b-dropdown>

  <b-card-body>
    <b-card no-body class="mb-1">
      <b-card-header header-tag="header" class="p-1 text-left" role="tab">
        <b-row block v-b-toggle.accordion-app-111>
            <b-col><p class="ml-3" variant="info">Ultra G-2 [user06074]</p></b-col>
            <b-col>9,490.00 тенге</b-col>
            <b-col class="actions-col"><b-button size="sm" variant="outline-warning"><b-icon icon="pause-fill" aria-hidden="true"></b-icon></b-button></b-col>
            <b-col class="actions-col"><b-button size="sm" variant="outline-primary"><b-icon icon="gear-fill" aria-hidden="true"></b-icon></b-button></b-col>
        </b-row>

      </b-card-header>
      <b-collapse id="accordion-app-111" accordion="app-accordion" role="tabpanel">
        <b-card-body>
          <b-container>
            <b-row>
              <b-col>Абонентская плата за пакет GOLD+</b-col>
              <b-col>9,490.00 тенге</b-col>
            </b-row>
          </b-container>
          <b-container>
            <b-row>
              <b-col>Аренда терминала ONT марки Eltex</b-col>
              <b-col>0.00 тенге</b-col>
            </b-row>
          </b-container>
        </b-card-body>
      </b-collapse>
    </b-card>

  </b-card-body>

</div>
</template>

<script>
export default {
  name: "AppsView"
}
</script>

<style scoped>

.actions-col {
    -ms-flex: 0 0 50px;
    flex: 0 0 50px;
    padding-left: 1px;
    padding-right: 1px;
}

</style>